/**
 * Unwrap Energy Section - Blast Animation
 * Images stack in center, then blast outward when section is 30% visible
 */

class UnwrapEnergySection extends HTMLElement {
  constructor() {
    super();
    this.hasAnimated = false;
  }

  connectedCallback() {
    this.setupAnimation();
  }

  setupAnimation() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.hasAnimated = true;
            this.triggerAnimation();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.4 }
    );

    observer.observe(this);
  }

  triggerAnimation() {
    // Phase 1: Stack rotates from 45deg to 5deg
    this.classList.add('animating');

    // Phase 2: Images blast out after stack rotation completes
    setTimeout(() => {
      this.classList.add('blasted');
    }, 300);
  }
}

customElements.define('unwrap-energy-section', UnwrapEnergySection);
